export default __webpack_public_path__ + "static/media/notification.37653859.svg";